module.exports = __webpack_public_path__ + "img/violet_015.aa9045de.png";